import { render, staticRenderFns } from "./behaviorConfig.vue?vue&type=template&id=2c0201ce&scoped=true"
import script from "./behaviorConfig.vue?vue&type=script&lang=js"
export * from "./behaviorConfig.vue?vue&type=script&lang=js"
import style0 from "./behaviorConfig.vue?vue&type=style&index=0&id=2c0201ce&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0201ce",
  null
  
)

export default component.exports